module.exports = __webpack_public_path__ + "static/media/Packshot_Filmdose_2019_Website.ec92c5da.png";